<template>
  <section class="section" style="margin-top: -40px;">
    <div class="container no-print">
      <div class="columns" >
        <div class="column" >
          <h2 class="title">
            ກວດສອບບັນຊີ ສາງ
          </h2>
        </div>
      </div>
      
      
      <b-tabs v-model="activeTab" v-if="roleid == 301" style="margin-top: -10px;  margin-left: -10px; margin-right: -10px;" >
            <b-tab-item label="ສະຫຼຸບບັນຊີສາງ" > 
              <b-field grouped>
                <b-field>
                  ການເຄື່ອນໄຫວ ບັນຊີສາງ
                </b-field>
                <b-field>
                  <b-datepicker
                     placeholder="ເລີ່ມ"
                    :date-formatter="dateFormatter"
                    v-model="startdate"
                  >
                  </b-datepicker>
                </b-field>
                <b-field>
                  <b-datepicker
                     placeholder="ເຖິງ"
                    :date-formatter="dateFormatter"
                    v-model="enddate"
                  >
                  </b-datepicker>
                </b-field>
                <b-field>
                  <b-button
                    class="btn-group-margin"
                    type="is-info"
                    @click="getPurchasePaymentList()"
                    >ເບິ່ງຂໍ້ມູນ
                  </b-button>
                </b-field>
                
              </b-field>
              <table class="table is-fullwidth is-narrow is-small" style="font-size: 14px;">
                <thead>
                  <tr>
                  
                    <th class="has-text-centered " width="2%">
                      #
                    </th>
                    <th class="has-text-left " width="3%">
                      ວັນທີ
                    </th>
                    <th class="has-text-right " width="8%">
                      ສົ້ມ
                    </th>
                    <th class="has-text-right " width="8%">
                      ນຸດ
                    </th>
                    <th class="has-text-right " width="8%">
                      ນວນ
                    </th>
                    <th class="has-text-right " width="8%">
                      ມີນາ
                    </th>
                    <th class="has-text-right " width="8%">
                      ເຜິ້ງ
                    </th>
                    <th class="has-text-right " width="8%">
                      ດ່າດ້າ
                    </th>
                    <th class="has-text-right " width="8%">
                      ຕ໋ອດ
                    </th>
                    <th class="has-text-right " width="8%">
                      ລວມທັງໝົດ
                    </th>
                    <th class="has-text-right " width="8%">
                      ຍອດເງິນໃນບັນຊີ<br>ກ່ອນໂອນ
                    </th>
                    <th class="has-text-right " width="8%">
                      ຍອດເງິນໃນບັນຊີ<br>ຫຼັງໂອນ
                    </th>
                    <th class="has-text-right " width="8%">
                      ຍອດສະສົມ<br>ອອກຕະຫຼາດ
                    </th>
                  
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(data, index) in purchaserPaymentList"
                    :key="data.ID"
                  >
                    <td class="has-text-centered">
                      {{ index +1  }}
                      
                    </td>
                    <td class="has-text-left">
                      {{ dateFormatter(data.REDATE) }}
                    </td>
                    <td class="has-text-right">
                      {{ data.M_SOM | formatNumberLocal }}<br>
                      {{ data.A_SOM | formatNumberLocal }}<br>
                      <span v-if="data.M_SOM != data.A_SOM" style="color: red;">{{ data.M_SOM - data.A_SOM | formatNumberLocal }}</span>
                      <span v-if="data.M_SOM == data.A_SOM">{{ data.M_SOM - data.A_SOM | formatNumberLocal }}</span>
                      
                    </td>

                    <td class="has-text-right">
                      {{ data.M_NOD | formatNumberLocal }}<br>
                      {{ data.A_NOD | formatNumberLocal }}<br>
                      <span v-if="data.M_NOD != data.A_NOD" style="color: red;">{{ data.M_NOD - data.A_NOD | formatNumberLocal }}</span>
                      <span v-if="data.M_NOD == data.A_NOD">{{ data.M_NOD - data.A_NOD | formatNumberLocal }}</span>
                      
                    </td>

                    <td class="has-text-right">
                      {{ data.M_NOUAN | formatNumberLocal }}<br>
                      {{ data.A_NOUAN | formatNumberLocal }}<br>
                      <span v-if="data.M_NOUAN != data.A_NOUAN" style="color: red;">{{ data.M_NOUAN - data.A_NOUAN | formatNumberLocal }}</span>
                      <span v-if="data.M_NOUAN == data.A_NOUAN">{{ data.M_NOUAN - data.A_NOUAN | formatNumberLocal }}</span>
                      
                    </td>

                    <td class="has-text-right">
                      {{ data.M_MINA | formatNumberLocal }}<br>
                      {{ data.A_MINA | formatNumberLocal }}<br>
                      <span v-if="data.M_MINA != data.A_MINA" style="color: red;">{{ data.M_MINA - data.A_MINA | formatNumberLocal }}</span>
                      <span v-if="data.M_MINA == data.A_MINA">{{ data.M_MINA - data.A_MINA | formatNumberLocal }}</span>
                      
                    </td>

                    <td class="has-text-right">
                      {{ data.M_PHEUN_MEAT_FISH | formatNumberLocal }}<br>
                      {{ data.A_PHEUN_MEAT_FISH | formatNumberLocal }}<br>
                      <span v-if="data.M_PHEUN_MEAT_FISH != data.A_PHEUN_MEAT_FISH" style="color: red;">{{ data.M_PHEUN_MEAT_FISH - data.A_PHEUN_MEAT_FISH | formatNumberLocal }}</span>
                      <span v-if="data.M_PHEUN_MEAT_FISH == data.A_PHEUN_MEAT_FISH">{{ data.M_PHEUN_MEAT_FISH - data.A_PHEUN_MEAT_FISH | formatNumberLocal }}</span>
                      
                    </td>

                    <td class="has-text-right">
                      {{ data.M_KHEM | formatNumberLocal }}<br>
                      {{ data.A_KHEM | formatNumberLocal }}<br>
                      <span v-if="data.M_KHEM != data.A_KHEM" style="color: red;">{{ data.M_KHEM - data.A_KHEM | formatNumberLocal }}</span>
                      <span v-if="data.M_KHEM == data.A_KHEM">{{ data.M_KHEM - data.A_KHEM | formatNumberLocal }}</span>
                      
                    </td>

                    <td class="has-text-right">
                      {{ data.M_TOD_STOCK | formatNumberLocal }}<br>
                      {{ data.A_TOD_STOCK | formatNumberLocal }}<br>
                      <span v-if="data.M_TOD_STOCK != data.A_TOD_STOCK" style="color: red;">{{ data.M_TOD_STOCK - data.A_TOD_STOCK | formatNumberLocal }}</span>
                      <span v-if="data.M_TOD_STOCK == data.A_TOD_STOCK">{{ data.M_TOD_STOCK - data.A_TOD_STOCK | formatNumberLocal }}</span>
                      
                    </td>
                    <td class="has-text-right">
                      {{ Number(data.M_SOM) + Number(data.M_NOD) + Number(data.M_NOUAN) + Number(data.M_MINA) + Number(data.M_PHEUN_MEAT_FISH) + Number(data.M_KHEM) + Number(data.M_TOD_STOCK) | formatNumberLocal }}<br>  
                      {{ Number(data.A_SOM) + Number(data.A_NOD) + Number(data.A_NOUAN) + Number(data.A_MINA) + Number(data.A_PHEUN_MEAT_FISH) + Number(data.A_KHEM) + Number(data.A_TOD_STOCK) | formatNumberLocal }}<br>
                      
                      <span v-if="(Number(data.M_SOM) + Number(data.M_NOD) + Number(data.M_NOUAN) + Number(data.M_MINA) + Number(data.M_PHEUN_MEAT_FISH) + Number(data.M_KHEM) + Number(data.M_TOD_STOCK)) != (Number(data.A_SOM) + Number(data.A_NOD) + Number(data.A_NOUAN) + Number(data.A_MINA) + Number(data.A_PHEUN_MEAT_FISH) + Number(data.A_KHEM) + Number(data.A_TOD_STOCK))" style="color: red;">
                        {{ (Number(data.M_SOM) + Number(data.M_NOD) + Number(data.M_NOUAN) + Number(data.M_MINA) + Number(data.M_PHEUN_MEAT_FISH) + Number(data.M_KHEM) + Number(data.M_TOD_STOCK)) - (Number(data.A_SOM) + Number(data.A_NOD) + Number(data.A_NOUAN) + Number(data.A_MINA) + Number(data.A_PHEUN_MEAT_FISH) + Number(data.A_KHEM) + Number(data.A_TOD_STOCK)) | formatNumberLocal }}
                      </span>
                    
                      <span  v-if="(Number(data.M_SOM) + Number(data.M_NOD) + Number(data.M_NOUAN) + Number(data.M_MINA) + Number(data.M_PHEUN_MEAT_FISH) + Number(data.M_KHEM) + Number(data.M_TOD_STOCK)) == (Number(data.A_SOM) + Number(data.A_NOD) + Number(data.A_NOUAN) + Number(data.A_MINA) + Number(data.A_PHEUN_MEAT_FISH) + Number(data.A_KHEM) + Number(data.A_TOD_STOCK))" >
                      0
                      </span>
                      <!-- {{ (data.M_SOM + data.M_NOD + data.M_NOUAN + data.M_MINA + data.M_PHEUN_MEAT_FISH + data.M_KHEM + data.M_TOD_STOCK) | formatNumberLocal }}<br>  
                      {{ data.A_SOM + data.A_NOD + data.A_NOUAN + data.A_MINA + data.A_PHEUN_MEAT_FISH + data.A_KHEM + data.A_TOD_STOCK | formatNumberLocal }}<br>
                      <span v-if="(data.M_SOM + data.M_NOD + data.M_NOUAN + data.M_MINA + data.M_PHEUN_MEAT_FISH + data.M_KHEM + data.M_TOD_STOCK) != (data.A_SOM + data.A_NOD + data.A_NOUAN + data.A_MINA + data.A_PHEUN_MEAT_FISH + data.A_KHEM + data.A_TOD_STOCK)" style="color: red;">
                          {{ (data.M_SOM + data.M_NOD + data.M_NOUAN + data.M_MINA + data.M_PHEUN_MEAT_FISH + data.M_KHEM + data.M_TOD_STOCK) - (data.A_SOM + data.A_NOD + data.A_NOUAN + data.A_MINA + data.A_PHEUN_MEAT_FISH + data.A_KHEM + data.A_TOD_STOCK) | formatNumberLocal }}
                      </span>
                      <span  v-if="(data.M_SOM + data.M_NOD + data.M_NOUAN + data.M_MINA + data.M_PHEUN_MEAT_FISH + data.M_KHEM + data.M_TOD_STOCK) != (data.A_SOM + data.A_NOD + data.A_NOUAN + data.A_MINA + data.A_PHEUN_MEAT_FISH + data.A_KHEM + data.A_TOD_STOCK)" >
                        {{ (data.M_SOM + data.M_NOD + data.M_NOUAN + data.M_MINA + data.M_PHEUN_MEAT_FISH + data.M_KHEM + data.M_TOD_STOCK) - (data.A_SOM + data.A_NOD + data.A_NOUAN + data.A_MINA + data.A_PHEUN_MEAT_FISH + data.A_KHEM + data.A_TOD_STOCK) | formatNumberLocal }}
                      </span> -->
                    </td> 
                    <td class="has-text-right">
      
                      <b-input v-if="data.ACCDATEAMOUNT2 ==0 || data.isEditACCDATEAMOUNT ==1"
                          v-model.trim="data.ACCDATEAMOUNT"   
                          type="number"   
                          min="0" 
                          placeholder="ຈຳນວນເງິນ"  
                          style="width: 130px; text-align: right; " 
                        >
                        </b-input> 
                        <b-button v-if="data.ACCDATEAMOUNT2 ==0 || data.isEditACCDATEAMOUNT ==1"
                          class="btn-group-margin"
                          type="is-success"  
                          size="is-small" 
                          @click="saveAccountDate(data.REDATE, data.ACCDATEAMOUNT, (Number(data.A_SOM) + Number(data.A_NOD) + Number(data.A_NOUAN) + Number(data.A_MINA) + Number(data.A_PHEUN_MEAT_FISH) + Number(data.A_KHEM) + Number(data.A_TOD_STOCK)))"
                          >ບັນທຶກ
                        </b-button>

                        <span v-if="data.isEditACCDATEAMOUNT ==0">
                          {{ data.ACCDATEAMOUNT | formatNumberLocal}}<br> 
                        </span>

                        <b-button v-if="data.ACCDATEAMOUNT2 >0 && data.isEditACCDATEAMOUNT ==0"
                          class="btn-group-margin"
                          type="is-warning"  
                          size="is-small" 
                          @click="editAccountDateForm(data.REDATE)"
                          >ແກ້ໄຂ
                        </b-button>
                        
                    </td>
                    <td class="has-text-right">
                      <span v-if="data.ACCAMOUNTAFFTERTRANSFER > 0">
                        {{ data.ACCAMOUNTAFFTERTRANSFER | formatNumberLocal}}
                      </span>
                      <span v-else>
                        {{ Number(data.A_SOM) + Number(data.A_NOD) + Number(data.A_NOUAN) + Number(data.A_MINA) + Number(data.A_PHEUN_MEAT_FISH) + Number(data.A_KHEM) + Number(data.A_TOD_STOCK) + Number(data.ACCDATEAMOUNT) | formatNumberLocal}}
                      </span>
                      
                    </td>
                    <td class="has-text-right">
                      <span v-if="data.ACCDATETOTAL > 0">
                        {{ data.ACCDATETOTAL | formatNumberLocal}}
                      </span>
                      <span v-else>
                        
                      </span>
                    </td>
                   
                    
                  </tr>
                </tbody>
              </table>

            </b-tab-item>
            <b-tab-item label="------">
              
            </b-tab-item>
          </b-tabs>

         
   </div>
  
    
  </section>
</template>

<script>

import RestAPI from "../../RestAPI";
// import Multiselect from "vue-multiselect";
import moment from "moment";

export default {
  // components: {Multiselect },
  props: ["MONTH"],
  data() {
    return {
      roleid: null,
      activeTab: 0,
      photopath:
        process.env.NODE_ENV === "production"
          ? "https://agrilao.com/manager-mainv2/api/uploads/"
          // : "http://localhost/agrilao-manager/api/uploads/",
          : "https://agrilao.com/manager-main/api/uploads/",

      purchaserPaymentList: [],
      startdate: null,
      enddate: null,


      selectedPurchaser: [],
      selectedAmount: 0,
      topupHistory: [],
      selectedOwnerName: null,
      selectedStatementTXDATE: null,
      statementDetail: [],

      isEditACCDATEAMOUNT: 0,
    };
  },
  methods: {
    editAccountDateForm(redate){
      const item = this.purchaserPaymentList.find(i => i.REDATE === redate); 
      if (item) {
        item.isEditACCDATEAMOUNT = 1;
      }
    },
    saveAccountDate(redate, accdateamount, totaluse){
      // console.log("redate: " + redate)
      // console.log("accdateamount: " + accdateamount)
      // console.log("totaluse: " + totaluse)
      // if(accdateamount ==0 || accdateamount == null){
      //   this.$swal("ຈຳນວນເງິນບໍ່ຖືກຕ້ອງ: ", "-", "error");
      //   return false;
      // }
      this.$swal({
        title: "ຕ້ອງການດຳເນີນການແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",
        confirmButtonColor: "#FF3860",
        cancelButtonColor: "#F7C325", 
        reverseButtons: true
      }).then((result) => {
        if (result.value) {   
          var params = {
            redate: redate,
            accdateamount: accdateamount,
            totaluse: totaluse,
            username: this.username,
          };
          console.log("params: " +JSON.stringify(params))
          RestAPI.saveAccountDate(params)
              .then(() => {
                this.getPurchasePaymentList();
                this.isEditACCDATEAMOUNT = 0;
                this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
          })
          .catch((error) => {
            console.log(error);
            if (error == "Error: Request failed with status code 400") {
              this.$swal("Check Input Data", "", "error");
            } else {
              this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
            }
          });
        }
      });
    },
    getStatementDetail(ID, TXDATE){
      this.selectedStatementTXDATE = TXDATE;
      this.activeTab = 2;
      RestAPI.getStatementDetail(ID)
        .then((res) => {
          this.statementDetail = res.data;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    getStatementHitstoryByType(ownser, typeid) {
      RestAPI.getStatementHitstoryByType(ownser, typeid)
        .then((res) => {
          this.topupHistory = res.data;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    getStatementHitstory (owner, ownername) {
      RestAPI.getStatementHitstory(owner)
        .then((res) => {
          this.selectedOwnerName = ownername;
          this.activeTab = 1;
          this.topupHistory = res.data;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    // topupMoney(){ 

    //   this.$swal({
    //     title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
    //     showCancelButton: true,
    //     showCloseButton: true,
    //     confirmButtonText: "ຕ້ອງການ",
    //     cancelButtonText: "ບໍ່ຕ້ອງການ",
    //     confirmButtonColor: "#FF3860",
    //     cancelButtonColor: "#F7C325", 
    //     reverseButtons: true
    //   }).then((result) => {
    //     if (result.value) {   
    //       var params = {
    //         purchaserid: this.selectedPurchaser.ID,
    //         amount: this.selectedAmount,
    //         remark: this.selectedRemark,
    //         username: this.username,
    //       };
    //       // console.log("params: " +JSON.stringify(params))
    //       RestAPI.topupMoney(params)
    //           .then(() => {
    //           this.getPurchaserBalance();
    //           this.selectedPurchaser = [];
    //           this.selectedAmount = 0;
    //           this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
    //       })
    //       .catch((error) => {
    //         console.log(error);
    //         if (error == "Error: Request failed with status code 400") {
    //           this.$swal("Check Input Data", "", "error");
    //         } else {
    //           this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
    //         }
    //       });
    //     }
    //   });

    // },
  
    getPurchasePaymentList() {
      RestAPI.getPurchasePaymentList(this.dateFormatterYYYYMMDD(this.startdate), this.dateFormatterYYYYMMDD(this.enddate))
        .then((res) => {
          this.purchaserPaymentList = res.data;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    
    getImgUrl(photoname) {
      var photopreview = photoname
        ? this.photopath + photoname
        : this.photopath + "unknown.png";
      return photopreview;
    },

    dateFormatter(date) {
      return new moment(date).format("DD/MM/YYYY");
    },
    dateFormatterYYYYMMDD(date) {
      return new moment(date).format("YYYY-MM-DD");
    },
    year(date) {
      return new moment(date).format("YYYY");
    },

    
  },
  mounted() {
    this.roleid = this.user.ROLEID;
    this.username = this.user.USERNAME;
    this.currentDate = new Date();
    this.startdate = new Date(
      this.currentDate.getFullYear(),
      this.currentDate.getMonth(),
      1
    );
    this.enddate = new Date(
      this.currentDate.getFullYear(),
      this.currentDate.getMonth() + 1,
      0
    );
  

    this.getPurchasePaymentList();


  },

  computed: {
    formdatestr() {
      return new moment(this.formdate).format("YYYY-MM-DD");
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.small-input input {
  font-size: 13px !important;
  text-align: right;
}
.popup {
  display: block;
  position: fixed;
  z-index: 1;
  padding-top: 60px;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.9);
}

/* Style for the close button */
.close {
  position: absolute;
  top: 15px;
  right: 35px;
  color: #f1f1f1;
  font-size: 40px;
  font-weight: bold;
  transition: 0.3s;
}

.close:hover,
.close:focus {
  color: #bbb;
  text-decoration: none;
  cursor: pointer;
}

/* Style for the popup content (image) */
.popup-content {
  margin: auto;
  display: block;
  width: 80%;
  max-width: 700px;
}

/* Add animation (optional) */
.popup-content {
  -webkit-animation-name: zoom;
  -webkit-animation-duration: 0.6s;
  animation-name: zoom;
  animation-duration: 0.6s;
}

@-webkit-keyframes zoom {
  from { -webkit-transform: scale(0); }
  to { -webkit-transform: scale(1); }
}

@keyframes zoom {
  from { transform: scale(0); }
  to { transform: scale(1); }
}

/* .text-right-input input {
  text-align: right;
} */

.custom-align {
    text-align: right;
}
.asterisk {
  color: red;
}

.set-border {
  border: 1px solid #ddd;
}

/* .summary-footer {
  page-break-before: always;
} */

.modal {
  display: none;
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.4);
}

/* Style for the modal content */
.modal-content {
  background-color: #fefefe;
  margin: 15% auto;
  padding: 20px;
  border: 1px solid #888;
  width: 80%;
}

/* Style for the close button */
.close {
  color: #aaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}

@media print {
  @page {
    margin-top: 0; /* Set the initial margin for the first page */
  }
}
</style>
